import { Link } from "react-router-dom";
import { SocialExternalLinks } from "@/components/SocialExternalLinks";

const Footer = () => (
  <footer className="mt-auto border-t border-border bg-surface-sunken py-8 md:py-9">
    <div className="mx-auto flex max-w-[80rem] flex-col gap-7 px-5 md:flex-row md:items-end md:justify-between md:px-9">
      <div>
        <p className="font-display text-sm font-bold uppercase tracking-[0.14em] text-foreground">Popistant</p>
        <p className="mt-1.5 max-w-sm text-xs text-muted-foreground">
          Conciertos, novedades y música a descubrir.
        </p>
        <div className="mt-3.5 w-full max-w-md text-xs text-muted-foreground">
          <SocialExternalLinks className="w-full" />
        </div>
      </div>
      <div className="space-y-2.5 text-xs text-muted-foreground">
        <div className="flex flex-wrap gap-4">
          <Link to="/feed" className="hover:text-foreground">Conciertos</Link>
          <Link to="/playlists" className="hover:text-foreground">Playlists</Link>
          <Link to="/articulos" className="hover:text-foreground">Artículos</Link>
          <Link to="/contacto" className="hover:text-foreground">Contacto</Link>
        </div>
        <div className="flex flex-wrap gap-4 text-[11px]">
          <Link to="/aviso-legal" className="hover:text-foreground">Aviso legal</Link>
          <Link to="/privacidad" className="hover:text-foreground">Privacidad</Link>
          <Link to="/cookies" className="hover:text-foreground">Cookies</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
